function percolating() {
	POP.poller = POP.poller || {};
    POP.poller = {
        continuePoll: true,
        default: 2000,
        timeout: 2000,
        id: null,
        max: 300000
    };

	_.extend(POP.poller, {
		STEPS: [
            'queued',
            'signup',
            'started',
            'register_domain',
            'set_user_active',
            'capture_charge',
            'finalize',
            'completed'
		],
		messages: [
			'Hold your horses...',
			'Patience is a virtue...',
			'Almost there...',
			'Patience wins the race...',
			'Hang in there...',
            'Keep your pants on...',
            'You have the patience of a saint'
		],
		messageIdx: null,
        geekMode: true,
        sameStatus: 0,

        /**
         * Initialize the poller.
         */
		start: function() {
			//send kissmetrics event "Percolator-Start"
			$('#percolatorstart').trigger('click');

            POP.poller.$text = $('#text-status');
			POP.poller.$geekText = $('#text-geek');

			POP.poller.$progress = $('.progress-bar');
            POP.poller.$progressSpan = POP.poller.$progress.find('span');

            POP.poller.enableBindings();

			POP.poller.lastPct = 0;
			POP.poller.continuePoll = true;
			POP.poller.id = setTimeout($.proxy(this, 'poll'), POP.poller['default']);
		},

        /**
         * Enabling any page bindings.
         */
        enableBindings: function() {
            $('#btn-geek-mode').on('click', $.proxy(this, 'toggleGeekMode'));
        },

        /**
         * Handle toggling geek mode on and off.
         */
        toggleGeekMode: function(e) {
            var $btn = $('#btn-geek-mode'),
                $navbar = $btn.closest('nav'),
                isEnabled = $navbar.hasClass('navbar-geek');

            if (isEnabled) {
                POP.poller.geekMode = false;
                $navbar.removeClass('navbar-geek');
                $btn.find('span').text('Turn on Geek Mode');
            } else {
                POP.poller.geekMode = true;
                $navbar.addClass('navbar-geek');
                $btn.find('span').text('Turn off Geek Mode');
            }

            return false;
        },

        /**
         * Handling polling.
         */
		poll: function() {
            var data;

			// Do we have a poll value? If so, increment it.
			if (typeof (POP.poller.timeout) != 'undefined' && !POP.poller.timeout) {
				POP.poller.timeout = POP.poller['default'];
			} else {
				POP.poller.timeout += POP.poller['default'];
			}

			// Have we been polling forever? Give up.
			if (POP.poller.timeout > POP.poller.max) {
				POP.poller.continuePoll = false;

				clearInterval(POP.poller.id);

				//this.showPopStatus('Registration seems to be taking longer than expected. We&rsquo;ll get ahold of you when it&rsquo;s complete.');
				setTimeout(this.loginRedirect, 1000);

			}

			if (POP.poller.continuePoll) {
				data = {
                    domain: POP.params.domain,
                    domain_id: POP.params.domain_id
                };

                void 0;
                void 0;

				$.ajax({
					type: 'POST',
					url: POP.apiBaseUrl + '/register/progress/',
					data: data,
					success: $.proxy(this, 'handleResponse'),
					error: $.proxy(this, 'handleResponse'),
					headers: {'X-Requested-With': 'XMLHttpRequest'},
					crossDomain: true,
					dataType: 'json'
				});
			}
		},

        /**
         * Handle poll response.
         */
		handleResponse: function(response) {

            // now that we're handling response, we can trigger next poll
            POP.poller.id = setTimeout($.proxy(this, 'poll'), POP.poller['default']);

            // handle success vs. error
			if (response.code == 200) {
				if (response.data.login == true) {
					POP.poller.continuePoll = false;

                    clearInterval(POP.poller.id);

                    this.renderStatus(
                        response.data.step,
                        'You\'re in! Ushering you through the crowd.',
                        'Registration has completed successfully. Redirecting.'
                    );

					void 0;

                    // set valid session cookies
                    $.cookie('pop_weasel', response.data.token, { path: '/', domain: '.pop.co' });
					$.cookie('pop_domain', POP.params.domain, { path: '/', domain: '.pop.co' });

                    // remove other cookies to prevent re-hitting the percolator
                    $.removeCookie('pop_domain_id', { path: '/', domain: '.pop.co' });
                    $.removeCookie('pop_email', { path: '/', domain: '.pop.co' });

                    //send kissmetrics event "Percolator-End"
					$('#percolatorend').trigger('click');

					setTimeout(this.loginRedirect, 1000);

                    return true;
				}

                // if the message is new
                if (response.data.status != POP.params.lastStatus) {
                    // reset same status counter
                    this.sameStatus = 0;

                    // update status
                    this.renderStatus(
                        response.data.step,
                        response.data.status,
                        response.data.geek
                    );

                    // set the last known status
                    POP.params.lastStatus = response.data.status;
                } else {
                    // if we've had the same status for 5 consecutive, show a random message
                    this.sameStatus++;
                    if (this.sameStatus >= 6) {
                        this.randomMessage(
                            response.data.step,
                            response.data.status,
                            response.data.geek
                        );
                    }
                }

			} else {
                // remove other cookies to prevent re-hitting the percolator
                $.removeCookie('pop_domain_id', { path: '/', domain: '.pop.co' });
                $.removeCookie('pop_email', { path: '/', domain: '.pop.co' });

                // special case error
                if (!response.status && response.msg) {
                    // render status with unknown step
                    this.renderStatus(
                        '',
                        response.msg,
                        'An error has occurred.'
                    );
                } else {
                    // render status with unknown step
                    this.renderStatus(
                        '',
                        response.status,
                        response.geek
                    );
                }

                // stop poller
				POP.poller.continuePoll = false;

                // clear poller intervals
				clearInterval(POP.poller.id);
                POP.poller.id = null;
			}
		},

        /**
         * Generate a random message.
         */
		randomMessage: function(step, status, geek) {
			var l = this.messages.length,
                index;

            // reset sameStatus
            this.sameStatus = 0;

            while (true) {
                index = Math.floor(Math.random() * l);
                if (index != this.messageIdx) {
                    this.messageIdx = index;
                    this.renderStatus(step, this.messages[index], geek);
                    return;
                }
            }
		},

        /**
         * Handle updating the current status (progress).
         */
		renderStatus: function(step, status, geek) {
			var idx = this.STEPS.indexOf(step),
                pct;

			if (idx !== -1) {
				pct = (idx / this.STEPS.length) * 100;
				if (pct > 90) {
                    pct = 100;
                }

                //this.$progress.css('width', pct + '%');
                this.$progress.animate({ width: pct + '%' }, 200);
                this.$progressSpan.text(pct + '% Complete');
			}

            // show both text versions
            this.$text.html(status);
			POP.scrollTo(this.$geekText.html(geek));
		},

        /**
         * Upon completion of progress loading, redirect to login.
         */
		loginRedirect: function() {
			window.location = '/panel/?onboard';
			return false;
		}

	});

	POP.poller.start();
}
